import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainCourseRoutingModule } from './main-course-routing.module';


// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';


// IMPORT COURSE MODULE COMPONENTS

import { CoursesComponent } from '../courses.component';
import { AddCourseModalComponent } from '../add-course-modal/add-course-modal.component';
import { EditCourseModalComponent } from '../edit-course-modal/edit-course-modal.component';
import { MaterialsComponent } from '../materials/materials.component';
import { AddMaterialModalComponent } from '../materials/add-material-modal/add-material-modal.component';
import { EditMaterialModalComponent } from '../materials/edit-material-modal/edit-material-modal.component';
import { MaterialComponent } from '../materials/material/material.component';
import { CourseChangeConfirmComponent } from '../course-change-confirm/course-change-confirm.component';
import { AddUnitModalComponent } from '../units/add-unit-modal/add-unit-modal.component';
import { UnitTileComponent } from '../units/unit-tile/unit-tile.component';
import { UnitsComponent } from '../units/units.component';
import { QuizListComponent } from '../quiz-list/quiz-list.component';
import { MainCourseComponent } from './main-course.component';
import { AllotmentConfirmationComponent } from '../assignment-status/allotment-confirmation/allotment-confirmation.component';
import { AssignmentStatusComponent } from '../assignment-status/assignment-status.component';
import { AssignmentRowComponent } from '../assignment-row/assignment-row.component';
import { AssignmentResourceComponent } from '../assignment-resource/assignment-resource.component';


@NgModule({
  declarations: [
    MainCourseComponent,
    CoursesComponent,
    AddCourseModalComponent,
    EditCourseModalComponent,
    MaterialsComponent,
    AddMaterialModalComponent,
    EditMaterialModalComponent,
    MaterialComponent,
    CourseChangeConfirmComponent,
    UnitsComponent,
    UnitTileComponent,
    AddUnitModalComponent,
    QuizListComponent,
    AssignmentStatusComponent,
    AllotmentConfirmationComponent,
    AssignmentRowComponent,
    AssignmentResourceComponent,
  ],
  imports: [
    CommonModule,
    MainCourseRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  entryComponents: [
    AddCourseModalComponent,
    EditCourseModalComponent,
    AddMaterialModalComponent,
    EditMaterialModalComponent,
    CourseChangeConfirmComponent,
    AddUnitModalComponent,
    AllotmentConfirmationComponent
  ],
  exports: [
    CoursesComponent,
    MaterialsComponent,
    UnitTileComponent,
    AssignmentStatusComponent,
    // AllotmentConfirmationComponent,
    AssignmentRowComponent,
    AssignmentResourceComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainCourseModule { }
